import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleCheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyleCheckBox = styled.input`
  width: 18px;
  height: 18px;
  border: 2px solid black;
  border-radius: 4px;
  appearance: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;

  &:checked {
    background-color: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
  }

  &:checked::after {
    content: '✓';
    color: white;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
  }

  &:hover {
    border-color: black;
  }
`

export const StyleErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`
